import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
class i extends a {
  /**
   * Fetches messaging stats.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/messaging/stats`
   *
   * @returns {Promise<MessagingSettingsStats>} A promise resolving to an object containg messaging stats.
   */
  getMessagingStats = async (s) => {
    const { data: t } = await this.get("messaging/stats", s);
    return t;
  };
}
export {
  i as MessagingStats,
  i as default
};
